


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TAcquisitionMode, TMode } from '@/plugins/podolib/services/helper/mixins/chart';
//
import ChartsGroupEvolutionWalkingPhase from '@/components/charts/groups/ChartsGroupEvolutionWalkingPhase.vue';
import ChartsGroupEvolutionOscillatingPhase from '@/components/charts/groups/ChartsGroupEvolutionOscillatingPhase.vue';
import ChartsGroupEvolutionStancePhase from '@/components/charts/groups/ChartsGroupEvolutionStancePhase.vue';
import ChartsGroupEvolutionStepSequencePhase from '@/components/charts/groups/ChartsGroupEvolutionStepSequencePhase.vue';
import ChartsGroupEvolutionNewRunningParameters from '@/components/charts/groups/ChartsGroupEvolutionNewRunningParameters.vue';

@Component({
  components: {
    ChartsGroupEvolutionWalkingPhase,
    ChartsGroupEvolutionOscillatingPhase,
    ChartsGroupEvolutionStancePhase,
    ChartsGroupEvolutionStepSequencePhase,
    ChartsGroupEvolutionNewRunningParameters,
  },
  async beforeRouteEnter(to, from, next) {
    await next();
    if (from.name === 'patient') {
      // Analytics
      Vue.prototype.$pdc.analytics.actions.trackSuccess('Patient EvolutionViewed', {
        patientId: to.params.id,
      });
    }
  },
})
export default class PagePatientEvolution extends Vue {
  @Prop({ required: true }) private patient!: TPatient;

  private relativeMode = false;
  private acquisitionType: TAcquisitionMode = 'standard';
  private acquisitionTypes: any = [
    {
      id: 'standard',
      name: 'commons.standards.walk',
      color: 'primary',
      icon: '$vuetify.walking--r',
    },
    {
      id: 'running',
      name: 'commons.standards.run',
      color: 'success',
      icon: '$vuetify.running--r',
    },
    /*{
        name: 'vionic',
        color: 'error',
        icon: '$vuetify.dumbbell--r',
        description: 'Accusamus ad assumenda consectetur est itaque molestiae.',
        actions: ['sentences.start-new-acquisition']
      }*/
  ];
  private showNewParameters = false;

  get mode(): TMode {
    return this.relativeMode ? 'relative' : 'absolute';
  }
  get standardAcquisitions() {
    return this.patient.acquisitions
      .filter(
        (x: any) =>
          x.analysisType.toLowerCase() === 'podosmart' && x.computed_data.valid !== 1 && x.computed_data.valid !== 0,
      )
      .reverse();
  }
  get runningAcquisitions() {
    return this.patient.acquisitions.filter((x: any) => x.analysisType === 'podorun').reverse();
  }
  get newsParametersAcquisitions() {
    return this.acquisitionType === 'standard'
      ? this.acquisitionsByType
      : this.acquisitionsByType.filter((x: any) => this.$pdc.helper!.isNewAnalysis(x.computed_data));
  }
  get findToggleColor() {
    let aqType = this.acquisitionTypes.find((x: any) => x.id === this.acquisitionType);
    return aqType.color;
  }
  get acquisitionsByType() {
    switch (this.acquisitionType) {
      case 'running':
        return this.runningAcquisitions;
      default:
        return this.standardAcquisitions;
    }
  }
  get acquisitionLength() {
    // @ts-ignore
    return this[this.acquisitionType + 'Acquisitions'].length;
  }
}
